











import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {Prop} from "vue-property-decorator";

@Component({
  components: {}
})
export default class HelpTooltip extends BasicComponent {

  @Prop(Boolean) inline: boolean;

}

